import { emit } from './eventBus'

/** @readonly */
export const CONNECTIONS_EVENTS = {
  TOOLKITS_CHANGED: 'connections:toolkits_changed',
}

/** @param {{ slugs?: string[] }} [payload] */
export function emitConnectionsToolkitsChanged(payload) {
  emit(CONNECTIONS_EVENTS.TOOLKITS_CHANGED, payload ?? {})
}
